const keyboardSilhouetteLayouts = {
    "forty": {
        "width": "294.74px",
        "height": "110.53px",
        "ratio": "294.736842/110.526316",
        "plateX": "1.90000%",
        "plateY": "5.06667%",
        "keys": [
            {
                "left": "3.21429%",
                "top": "8.57143%",
                "width": "6.78571%",
                "height": "19.04762%"
            },
            {
                "left": "11.07143%",
                "top": "8.57143%",
                "width": "6.78571%",
                "height": "19.04762%"
            },
            {
                "left": "19.28571%",
                "top": "8.57143%",
                "width": "6.42857%",
                "height": "19.04762%"
            },
            {
                "left": "26.78571%",
                "top": "8.57143%",
                "width": "6.78571%",
                "height": "19.04762%"
            },
            {
                "left": "35.00000%",
                "top": "8.57143%",
                "width": "6.78571%",
                "height": "19.04762%"
            },
            {
                "left": "42.50000%",
                "top": "8.57143%",
                "width": "7.14286%",
                "height": "19.04762%"
            },
            {
                "left": "50.71429%",
                "top": "8.57143%",
                "width": "6.78571%",
                "height": "19.04762%"
            },
            {
                "left": "58.57143%",
                "top": "8.57143%",
                "width": "6.78571%",
                "height": "19.04762%"
            },
            {
                "left": "66.42857%",
                "top": "8.57143%",
                "width": "6.78571%",
                "height": "19.04762%"
            },
            {
                "left": "74.28571%",
                "top": "8.57143%",
                "width": "6.78571%",
                "height": "19.04762%"
            },
            {
                "left": "82.50000%",
                "top": "8.57143%",
                "width": "6.78571%",
                "height": "19.04762%"
            },
            {
                "left": "90.00000%",
                "top": "8.57143%",
                "width": "6.78571%",
                "height": "19.04762%"
            },
            {
                "left": "3.21429%",
                "top": "30.47619%",
                "width": "9.64286%",
                "height": "18.09524%"
            },
            {
                "left": "13.92857%",
                "top": "30.47619%",
                "width": "7.14286%",
                "height": "18.09524%"
            },
            {
                "left": "22.14286%",
                "top": "30.47619%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "30.00000%",
                "top": "30.47619%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "37.85714%",
                "top": "30.47619%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "45.71429%",
                "top": "30.47619%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "53.92857%",
                "top": "30.47619%",
                "width": "6.42857%",
                "height": "18.09524%"
            },
            {
                "left": "61.42857%",
                "top": "30.47619%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "69.64286%",
                "top": "30.47619%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "77.50000%",
                "top": "30.47619%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "85.35714%",
                "top": "30.47619%",
                "width": "11.42857%",
                "height": "18.09524%"
            },
            {
                "left": "3.21429%",
                "top": "52.38095%",
                "width": "11.42857%",
                "height": "18.09524%"
            },
            {
                "left": "15.71429%",
                "top": "52.38095%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "23.92857%",
                "top": "52.38095%",
                "width": "6.42857%",
                "height": "18.09524%"
            },
            {
                "left": "31.78571%",
                "top": "52.38095%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "39.64286%",
                "top": "52.38095%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "47.50000%",
                "top": "52.38095%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "55.35714%",
                "top": "52.38095%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "63.57143%",
                "top": "52.38095%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "71.07143%",
                "top": "52.38095%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "79.28571%",
                "top": "52.38095%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "87.14286%",
                "top": "52.38095%",
                "width": "9.64286%",
                "height": "18.09524%"
            },
            {
                "left": "3.21429%",
                "top": "73.33333%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "11.07143%",
                "top": "73.33333%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "19.28571%",
                "top": "73.33333%",
                "width": "6.42857%",
                "height": "18.09524%"
            },
            {
                "left": "27.14286%",
                "top": "73.33333%",
                "width": "46.07143%",
                "height": "18.09524%"
            },
            {
                "left": "74.28571%",
                "top": "73.33333%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "82.50000%",
                "top": "73.33333%",
                "width": "6.78571%",
                "height": "18.09524%"
            },
            {
                "left": "90.00000%",
                "top": "73.33333%",
                "width": "6.78571%",
                "height": "18.09524%"
            }
        ]
    },
    "fifty": {
        "width": "380.0px",
        "height": "109.47px",
        "ratio": "380.000000/109.473684",
        "plateX": "1.47368%",
        "plateY": "5.11538%",
        "keys": [
            {
                "left": "2.49307%",
                "top": "8.65385%",
                "width": "5.26316%",
                "height": "18.26923%"
            },
            {
                "left": "9.97230%",
                "top": "8.65385%",
                "width": "7.47922%",
                "height": "18.26923%"
            },
            {
                "left": "18.55956%",
                "top": "8.65385%",
                "width": "4.98615%",
                "height": "18.26923%"
            },
            {
                "left": "24.65374%",
                "top": "8.65385%",
                "width": "5.26316%",
                "height": "18.26923%"
            },
            {
                "left": "30.74792%",
                "top": "8.65385%",
                "width": "4.98615%",
                "height": "18.26923%"
            },
            {
                "left": "36.84211%",
                "top": "8.65385%",
                "width": "5.26316%",
                "height": "18.26923%"
            },
            {
                "left": "42.93629%",
                "top": "8.65385%",
                "width": "5.26316%",
                "height": "18.26923%"
            },
            {
                "left": "49.30748%",
                "top": "8.65385%",
                "width": "4.98615%",
                "height": "18.26923%"
            },
            {
                "left": "55.40166%",
                "top": "8.65385%",
                "width": "4.98615%",
                "height": "17.30769%"
            },
            {
                "left": "61.49584%",
                "top": "8.65385%",
                "width": "4.98615%",
                "height": "18.26923%"
            },
            {
                "left": "67.59003%",
                "top": "8.65385%",
                "width": "4.98615%",
                "height": "18.26923%"
            },
            {
                "left": "73.68421%",
                "top": "8.65385%",
                "width": "5.26316%",
                "height": "17.30769%"
            },
            {
                "left": "79.77839%",
                "top": "8.65385%",
                "width": "5.26316%",
                "height": "18.26923%"
            },
            {
                "left": "86.14958%",
                "top": "8.65385%",
                "width": "4.98615%",
                "height": "18.26923%"
            },
            {
                "left": "92.52078%",
                "top": "8.65385%",
                "width": "4.98615%",
                "height": "18.26923%"
            },
            {
                "left": "2.77008%",
                "top": "29.80769%",
                "width": "4.98615%",
                "height": "17.30769%"
            },
            {
                "left": "9.97230%",
                "top": "29.80769%",
                "width": "8.58726%",
                "height": "18.26923%"
            },
            {
                "left": "19.66759%",
                "top": "29.80769%",
                "width": "4.98615%",
                "height": "17.30769%"
            },
            {
                "left": "25.76177%",
                "top": "29.80769%",
                "width": "5.26316%",
                "height": "18.26923%"
            },
            {
                "left": "31.85596%",
                "top": "29.80769%",
                "width": "5.26316%",
                "height": "18.26923%"
            },
            {
                "left": "37.95014%",
                "top": "29.80769%",
                "width": "5.26316%",
                "height": "18.26923%"
            },
            {
                "left": "44.32133%",
                "top": "29.80769%",
                "width": "4.98615%",
                "height": "17.30769%"
            },
            {
                "left": "50.13850%",
                "top": "29.80769%",
                "width": "5.26316%",
                "height": "17.30769%"
            },
            {
                "left": "56.50970%",
                "top": "29.80769%",
                "width": "4.98615%",
                "height": "17.30769%"
            },
            {
                "left": "62.60388%",
                "top": "29.80769%",
                "width": "4.98615%",
                "height": "18.26923%"
            },
            {
                "left": "68.69806%",
                "top": "29.80769%",
                "width": "4.98615%",
                "height": "18.26923%"
            },
            {
                "left": "74.79224%",
                "top": "29.80769%",
                "width": "5.26316%",
                "height": "18.26923%"
            },
            {
                "left": "81.16343%",
                "top": "29.80769%",
                "width": "4.98615%",
                "height": "18.26923%"
            },
            {
                "left": "87.25762%",
                "top": "29.80769%",
                "width": "10.24931%",
                "height": "18.26923%"
            },
            {
                "left": "2.77008%",
                "top": "51.92308%",
                "width": "4.98615%",
                "height": "17.30769%"
            },
            {
                "left": "9.97230%",
                "top": "51.92308%",
                "width": "9.97230%",
                "height": "17.30769%"
            },
            {
                "left": "20.77562%",
                "top": "51.92308%",
                "width": "5.26316%",
                "height": "17.30769%"
            },
            {
                "left": "27.14681%",
                "top": "51.92308%",
                "width": "4.98615%",
                "height": "17.30769%"
            },
            {
                "left": "33.24100%",
                "top": "51.92308%",
                "width": "4.98615%",
                "height": "17.30769%"
            },
            {
                "left": "39.33518%",
                "top": "51.92308%",
                "width": "5.26316%",
                "height": "17.30769%"
            },
            {
                "left": "45.42936%",
                "top": "51.92308%",
                "width": "4.98615%",
                "height": "17.30769%"
            },
            {
                "left": "51.80055%",
                "top": "51.92308%",
                "width": "4.98615%",
                "height": "17.30769%"
            },
            {
                "left": "57.61773%",
                "top": "51.92308%",
                "width": "5.26316%",
                "height": "17.30769%"
            },
            {
                "left": "63.98892%",
                "top": "51.92308%",
                "width": "4.98615%",
                "height": "17.30769%"
            },
            {
                "left": "70.08310%",
                "top": "51.92308%",
                "width": "4.98615%",
                "height": "17.30769%"
            },
            {
                "left": "76.17729%",
                "top": "51.92308%",
                "width": "5.26316%",
                "height": "17.30769%"
            },
            {
                "left": "82.54848%",
                "top": "51.92308%",
                "width": "14.95845%",
                "height": "17.30769%"
            },
            {
                "left": "2.77008%",
                "top": "73.07692%",
                "width": "4.98615%",
                "height": "18.26923%"
            },
            {
                "left": "14.12742%",
                "top": "73.07692%",
                "width": "6.37119%",
                "height": "18.26923%"
            },
            {
                "left": "21.32964%",
                "top": "74.03846%",
                "width": "6.09418%",
                "height": "17.30769%"
            },
            {
                "left": "28.53186%",
                "top": "73.07692%",
                "width": "6.09418%",
                "height": "18.26923%"
            },
            {
                "left": "36.01108%",
                "top": "73.07692%",
                "width": "35.45706%",
                "height": "18.26923%"
            },
            {
                "left": "72.57618%",
                "top": "74.03846%",
                "width": "6.09418%",
                "height": "17.30769%"
            },
            {
                "left": "79.77839%",
                "top": "74.03846%",
                "width": "6.09418%",
                "height": "17.30769%"
            },
            {
                "left": "86.98061%",
                "top": "73.07692%",
                "width": "6.09418%",
                "height": "18.26923%"
            }
        ]
    },
    "compact": {
        "width": "373.0px",
        "height": "137.0px",
        "ratio": "373.000000/137.000000",
        "plateX": "1.50134%",
        "plateY": "4.08759%",
        "keys": [
            {
                "left": "2.41287%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "8.84718%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "15.54960%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "21.98391%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "28.41823%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "34.85255%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "41.55496%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "47.98928%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "54.69169%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "60.85791%",
                "top": "6.56934%",
                "width": "5.63003%",
                "height": "14.59854%"
            },
            {
                "left": "67.56032%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "73.99464%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "80.69705%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "87.13137%",
                "top": "6.56934%",
                "width": "10.45576%",
                "height": "14.59854%"
            },
            {
                "left": "2.41287%",
                "top": "24.81752%",
                "width": "7.77480%",
                "height": "14.59854%"
            },
            {
                "left": "11.26005%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "17.96247%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "24.39678%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "31.09920%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "37.26542%",
                "top": "24.81752%",
                "width": "5.63003%",
                "height": "14.59854%"
            },
            {
                "left": "43.96783%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "50.40214%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "57.10456%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "63.53887%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "70.24129%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "76.67560%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "83.10992%",
                "top": "24.81752%",
                "width": "5.63003%",
                "height": "14.59854%"
            },
            {
                "left": "89.54424%",
                "top": "24.81752%",
                "width": "8.04290%",
                "height": "14.59854%"
            },
            {
                "left": "2.41287%",
                "top": "43.06569%",
                "width": "9.91957%",
                "height": "14.59854%"
            },
            {
                "left": "13.67292%",
                "top": "43.06569%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "20.10724%",
                "top": "43.06569%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "26.54155%",
                "top": "43.06569%",
                "width": "5.63003%",
                "height": "14.59854%"
            },
            {
                "left": "33.24397%",
                "top": "43.06569%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "39.67828%",
                "top": "43.06569%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "46.11260%",
                "top": "43.06569%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "52.54692%",
                "top": "43.06569%",
                "width": "5.63003%",
                "height": "14.59854%"
            },
            {
                "left": "59.24933%",
                "top": "43.06569%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "65.68365%",
                "top": "43.06569%",
                "width": "5.63003%",
                "height": "14.59854%"
            },
            {
                "left": "72.38606%",
                "top": "43.06569%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "78.82038%",
                "top": "43.06569%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "85.52279%",
                "top": "43.06569%",
                "width": "12.06434%",
                "height": "14.59854%"
            },
            {
                "left": "2.41287%",
                "top": "60.58394%",
                "width": "11.79625%",
                "height": "14.59854%"
            },
            {
                "left": "15.54960%",
                "top": "60.58394%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "21.98391%",
                "top": "60.58394%",
                "width": "5.63003%",
                "height": "14.59854%"
            },
            {
                "left": "28.41823%",
                "top": "60.58394%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "35.12064%",
                "top": "60.58394%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "41.55496%",
                "top": "60.58394%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "47.98928%",
                "top": "60.58394%",
                "width": "5.63003%",
                "height": "14.59854%"
            },
            {
                "left": "54.69169%",
                "top": "60.58394%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "61.12601%",
                "top": "60.58394%",
                "width": "5.63003%",
                "height": "14.59854%"
            },
            {
                "left": "67.82842%",
                "top": "60.58394%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "74.26273%",
                "top": "60.58394%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "80.69705%",
                "top": "60.58394%",
                "width": "16.89008%",
                "height": "14.59854%"
            },
            {
                "left": "2.41287%",
                "top": "78.83212%",
                "width": "6.43432%",
                "height": "14.59854%"
            },
            {
                "left": "9.91957%",
                "top": "78.83212%",
                "width": "6.70241%",
                "height": "14.59854%"
            },
            {
                "left": "17.69437%",
                "top": "78.83212%",
                "width": "6.43432%",
                "height": "14.59854%"
            },
            {
                "left": "25.20107%",
                "top": "78.83212%",
                "width": "41.82306%",
                "height": "14.59854%"
            },
            {
                "left": "68.09651%",
                "top": "78.83212%",
                "width": "6.70241%",
                "height": "14.59854%"
            },
            {
                "left": "75.60322%",
                "top": "78.83212%",
                "width": "6.70241%",
                "height": "14.59854%"
            },
            {
                "left": "83.37802%",
                "top": "78.83212%",
                "width": "6.43432%",
                "height": "14.59854%"
            },
            {
                "left": "91.15282%",
                "top": "78.83212%",
                "width": "6.43432%",
                "height": "14.59854%"
            }
        ]
    },
    "sixtyfive-exploded": {
        "width": "412.0px",
        "height": "142.0px",
        "ratio": "412.000000/142.000000",
        "plateX": "1.35922%",
        "plateY": "3.94366%",
        "keys": [
            {
                "left": "2.18447%",
                "top": "6.33803%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "8.00971%",
                "top": "6.33803%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "14.07767%",
                "top": "6.33803%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "19.66019%",
                "top": "6.33803%",
                "width": "5.09709%",
                "height": "14.08451%"
            },
            {
                "left": "25.72816%",
                "top": "6.33803%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "31.55340%",
                "top": "6.33803%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "37.62136%",
                "top": "6.33803%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "43.44660%",
                "top": "6.33803%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "49.51456%",
                "top": "6.33803%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "55.09709%",
                "top": "6.33803%",
                "width": "5.09709%",
                "height": "14.08451%"
            },
            {
                "left": "61.16505%",
                "top": "6.33803%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "66.99029%",
                "top": "6.33803%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "73.05825%",
                "top": "6.33803%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "78.88350%",
                "top": "6.33803%",
                "width": "11.16505%",
                "height": "14.08451%"
            },
            {
                "left": "92.47573%",
                "top": "6.33803%",
                "width": "4.85437%",
                "height": "14.78873%"
            },
            {
                "left": "2.18447%",
                "top": "23.94366%",
                "width": "7.03883%",
                "height": "14.08451%"
            },
            {
                "left": "10.19417%",
                "top": "23.94366%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "16.26214%",
                "top": "23.94366%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "22.08738%",
                "top": "23.94366%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "28.15534%",
                "top": "23.94366%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "33.73786%",
                "top": "23.94366%",
                "width": "5.09709%",
                "height": "14.08451%"
            },
            {
                "left": "39.80583%",
                "top": "23.94366%",
                "width": "5.09709%",
                "height": "14.08451%"
            },
            {
                "left": "45.63107%",
                "top": "23.94366%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "51.69903%",
                "top": "23.94366%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "57.52427%",
                "top": "23.94366%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "63.59223%",
                "top": "23.94366%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "69.41748%",
                "top": "23.94366%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "75.24272%",
                "top": "23.94366%",
                "width": "5.09709%",
                "height": "14.08451%"
            },
            {
                "left": "81.06796%",
                "top": "23.94366%",
                "width": "8.98058%",
                "height": "14.08451%"
            },
            {
                "left": "92.47573%",
                "top": "23.94366%",
                "width": "5.09709%",
                "height": "14.08451%"
            },
            {
                "left": "2.18447%",
                "top": "41.54930%",
                "width": "8.98058%",
                "height": "14.08451%"
            },
            {
                "left": "12.37864%",
                "top": "41.54930%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "18.20388%",
                "top": "41.54930%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "24.02913%",
                "top": "41.54930%",
                "width": "5.09709%",
                "height": "14.08451%"
            },
            {
                "left": "30.09709%",
                "top": "41.54930%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "35.92233%",
                "top": "41.54930%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "41.74757%",
                "top": "41.54930%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "47.57282%",
                "top": "41.54930%",
                "width": "5.09709%",
                "height": "14.08451%"
            },
            {
                "left": "53.64078%",
                "top": "41.54930%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "59.46602%",
                "top": "41.54930%",
                "width": "5.09709%",
                "height": "14.08451%"
            },
            {
                "left": "65.53398%",
                "top": "41.54930%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "71.35922%",
                "top": "41.54930%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "77.42718%",
                "top": "41.54930%",
                "width": "12.62136%",
                "height": "14.08451%"
            },
            {
                "left": "92.71845%",
                "top": "41.54930%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "2.18447%",
                "top": "58.45070%",
                "width": "10.67961%",
                "height": "14.08451%"
            },
            {
                "left": "14.07767%",
                "top": "58.45070%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "19.90291%",
                "top": "58.45070%",
                "width": "5.09709%",
                "height": "14.08451%"
            },
            {
                "left": "25.72816%",
                "top": "58.45070%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "31.79612%",
                "top": "58.45070%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "37.62136%",
                "top": "58.45070%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "43.44660%",
                "top": "58.45070%",
                "width": "5.09709%",
                "height": "14.08451%"
            },
            {
                "left": "49.51456%",
                "top": "58.45070%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "55.33981%",
                "top": "58.45070%",
                "width": "5.09709%",
                "height": "14.08451%"
            },
            {
                "left": "61.16505%",
                "top": "58.45070%",
                "width": "5.09709%",
                "height": "14.08451%"
            },
            {
                "left": "67.23301%",
                "top": "58.45070%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "73.05825%",
                "top": "58.45070%",
                "width": "11.16505%",
                "height": "14.08451%"
            },
            {
                "left": "86.89320%",
                "top": "62.67606%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "2.18447%",
                "top": "76.05634%",
                "width": "5.82524%",
                "height": "14.08451%"
            },
            {
                "left": "8.98058%",
                "top": "76.05634%",
                "width": "6.06796%",
                "height": "14.08451%"
            },
            {
                "left": "16.01942%",
                "top": "76.05634%",
                "width": "5.82524%",
                "height": "14.08451%"
            },
            {
                "left": "22.81553%",
                "top": "76.05634%",
                "width": "37.62136%",
                "height": "14.08451%"
            },
            {
                "left": "61.40777%",
                "top": "76.05634%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "67.47573%",
                "top": "76.05634%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "73.30097%",
                "top": "76.05634%",
                "width": "5.09709%",
                "height": "14.08451%"
            },
            {
                "left": "80.82524%",
                "top": "79.57746%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "86.89320%",
                "top": "79.57746%",
                "width": "4.85437%",
                "height": "14.08451%"
            },
            {
                "left": "92.71845%",
                "top": "79.57746%",
                "width": "5.09709%",
                "height": "14.08451%"
            }
        ]
    },
    "sixtyfive": {
        "width": "373.0px",
        "height": "137.0px",
        "ratio": "373.000000/137.000000",
        "plateX": "1.50134%",
        "plateY": "4.08759%",
        "keys": [
            {
                "left": "2.41287%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "8.84718%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "15.54960%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "21.98391%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "28.41823%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "34.85255%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "41.55496%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "47.98928%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "54.69169%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "60.85791%",
                "top": "6.56934%",
                "width": "5.63003%",
                "height": "14.59854%"
            },
            {
                "left": "67.56032%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "73.99464%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "80.69705%",
                "top": "6.56934%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "87.13137%",
                "top": "6.56934%",
                "width": "10.45576%",
                "height": "14.59854%"
            },
            {
                "left": "2.41287%",
                "top": "24.81752%",
                "width": "7.77480%",
                "height": "14.59854%"
            },
            {
                "left": "11.26005%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "17.96247%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "24.39678%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "31.09920%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "37.26542%",
                "top": "24.81752%",
                "width": "5.63003%",
                "height": "14.59854%"
            },
            {
                "left": "43.96783%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "50.40214%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "57.10456%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "63.53887%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "70.24129%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "76.67560%",
                "top": "24.81752%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "83.10992%",
                "top": "24.81752%",
                "width": "5.63003%",
                "height": "14.59854%"
            },
            {
                "left": "89.54424%",
                "top": "24.81752%",
                "width": "8.04290%",
                "height": "14.59854%"
            },
            {
                "left": "2.41287%",
                "top": "43.06569%",
                "width": "9.91957%",
                "height": "14.59854%"
            },
            {
                "left": "13.67292%",
                "top": "43.06569%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "20.10724%",
                "top": "43.06569%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "26.54155%",
                "top": "43.06569%",
                "width": "5.63003%",
                "height": "14.59854%"
            },
            {
                "left": "33.24397%",
                "top": "43.06569%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "39.67828%",
                "top": "43.06569%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "46.11260%",
                "top": "43.06569%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "52.54692%",
                "top": "43.06569%",
                "width": "5.63003%",
                "height": "14.59854%"
            },
            {
                "left": "59.24933%",
                "top": "43.06569%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "65.68365%",
                "top": "43.06569%",
                "width": "5.63003%",
                "height": "14.59854%"
            },
            {
                "left": "72.38606%",
                "top": "43.06569%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "78.82038%",
                "top": "43.06569%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "85.52279%",
                "top": "43.06569%",
                "width": "12.06434%",
                "height": "14.59854%"
            },
            {
                "left": "2.41287%",
                "top": "60.58394%",
                "width": "11.79625%",
                "height": "14.59854%"
            },
            {
                "left": "15.54960%",
                "top": "60.58394%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "21.98391%",
                "top": "60.58394%",
                "width": "5.63003%",
                "height": "14.59854%"
            },
            {
                "left": "28.41823%",
                "top": "60.58394%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "35.12064%",
                "top": "60.58394%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "41.55496%",
                "top": "60.58394%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "47.98928%",
                "top": "60.58394%",
                "width": "5.63003%",
                "height": "14.59854%"
            },
            {
                "left": "54.69169%",
                "top": "60.58394%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "61.12601%",
                "top": "60.58394%",
                "width": "5.63003%",
                "height": "14.59854%"
            },
            {
                "left": "67.82842%",
                "top": "60.58394%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "74.26273%",
                "top": "60.58394%",
                "width": "5.36193%",
                "height": "14.59854%"
            },
            {
                "left": "80.69705%",
                "top": "60.58394%",
                "width": "16.89008%",
                "height": "14.59854%"
            },
            {
                "left": "2.41287%",
                "top": "78.83212%",
                "width": "6.43432%",
                "height": "14.59854%"
            },
            {
                "left": "9.91957%",
                "top": "78.83212%",
                "width": "6.70241%",
                "height": "14.59854%"
            },
            {
                "left": "17.69437%",
                "top": "78.83212%",
                "width": "6.43432%",
                "height": "14.59854%"
            },
            {
                "left": "25.20107%",
                "top": "78.83212%",
                "width": "41.82306%",
                "height": "14.59854%"
            },
            {
                "left": "68.09651%",
                "top": "78.83212%",
                "width": "6.70241%",
                "height": "14.59854%"
            },
            {
                "left": "75.60322%",
                "top": "78.83212%",
                "width": "6.70241%",
                "height": "14.59854%"
            },
            {
                "left": "83.37802%",
                "top": "78.83212%",
                "width": "6.43432%",
                "height": "14.59854%"
            },
            {
                "left": "91.15282%",
                "top": "78.83212%",
                "width": "6.43432%",
                "height": "14.59854%"
            }
        ]
    },
    "seventyfive-exploded": {
        "width": "412.0px",
        "height": "173.0px",
        "ratio": "412.000000/173.000000",
        "plateX": "1.35922%",
        "plateY": "3.23699%",
        "keys": [
            {
                "left": "2.18447%",
                "top": "5.20231%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "9.46602%",
                "top": "5.20231%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "15.53398%",
                "top": "5.20231%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "21.60194%",
                "top": "5.20231%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "27.42718%",
                "top": "5.20231%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "34.95146%",
                "top": "5.20231%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "40.77670%",
                "top": "5.20231%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "46.60194%",
                "top": "5.20231%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "52.42718%",
                "top": "5.20231%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "60.19417%",
                "top": "5.20231%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "65.77670%",
                "top": "5.20231%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "71.84466%",
                "top": "5.20231%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "77.66990%",
                "top": "5.20231%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "85.19417%",
                "top": "5.20231%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "92.71845%",
                "top": "5.20231%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "2.18447%",
                "top": "23.12139%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "8.00971%",
                "top": "23.12139%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "14.07767%",
                "top": "23.12139%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "19.66019%",
                "top": "23.12139%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "25.72816%",
                "top": "23.12139%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "31.55340%",
                "top": "23.12139%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "37.62136%",
                "top": "23.12139%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "43.44660%",
                "top": "23.12139%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "49.51456%",
                "top": "23.12139%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "55.09709%",
                "top": "23.12139%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "61.16505%",
                "top": "23.12139%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "66.99029%",
                "top": "23.12139%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "73.05825%",
                "top": "23.12139%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "78.88350%",
                "top": "23.12139%",
                "width": "11.16505%",
                "height": "11.56069%"
            },
            {
                "left": "92.47573%",
                "top": "23.12139%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "2.18447%",
                "top": "37.57225%",
                "width": "7.03883%",
                "height": "11.56069%"
            },
            {
                "left": "10.19417%",
                "top": "37.57225%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "16.26214%",
                "top": "37.57225%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "22.08738%",
                "top": "37.57225%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "28.15534%",
                "top": "37.57225%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "33.73786%",
                "top": "37.57225%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "39.80583%",
                "top": "37.57225%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "45.63107%",
                "top": "37.57225%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "51.69903%",
                "top": "37.57225%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "57.52427%",
                "top": "37.57225%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "63.59223%",
                "top": "37.57225%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "69.41748%",
                "top": "37.57225%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "75.24272%",
                "top": "37.57225%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "81.06796%",
                "top": "37.57225%",
                "width": "8.98058%",
                "height": "11.56069%"
            },
            {
                "left": "92.47573%",
                "top": "37.57225%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "2.18447%",
                "top": "51.44509%",
                "width": "8.98058%",
                "height": "12.13873%"
            },
            {
                "left": "12.37864%",
                "top": "51.44509%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "18.20388%",
                "top": "51.44509%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "24.02913%",
                "top": "51.44509%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "30.09709%",
                "top": "51.44509%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "35.92233%",
                "top": "51.44509%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "41.74757%",
                "top": "51.44509%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "47.57282%",
                "top": "51.44509%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "53.64078%",
                "top": "51.44509%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "59.46602%",
                "top": "51.44509%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "65.53398%",
                "top": "51.44509%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "71.35922%",
                "top": "51.44509%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "77.42718%",
                "top": "51.44509%",
                "width": "12.62136%",
                "height": "11.56069%"
            },
            {
                "left": "92.71845%",
                "top": "51.44509%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "2.18447%",
                "top": "65.89595%",
                "width": "10.67961%",
                "height": "11.56069%"
            },
            {
                "left": "14.07767%",
                "top": "65.89595%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "19.90291%",
                "top": "65.89595%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "25.72816%",
                "top": "65.89595%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "31.79612%",
                "top": "65.89595%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "37.62136%",
                "top": "65.89595%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "43.44660%",
                "top": "65.89595%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "49.51456%",
                "top": "65.89595%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "55.33981%",
                "top": "65.89595%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "61.16505%",
                "top": "65.89595%",
                "width": "5.09709%",
                "height": "11.56069%"
            },
            {
                "left": "67.23301%",
                "top": "65.89595%",
                "width": "4.85437%",
                "height": "11.56069%"
            },
            {
                "left": "73.05825%",
                "top": "65.89595%",
                "width": "11.16505%",
                "height": "11.56069%"
            },
            {
                "left": "86.89320%",
                "top": "68.78613%",
                "width": "4.85437%",
                "height": "12.13873%"
            },
            {
                "left": "2.18447%",
                "top": "79.76879%",
                "width": "5.82524%",
                "height": "12.13873%"
            },
            {
                "left": "8.98058%",
                "top": "79.76879%",
                "width": "6.06796%",
                "height": "12.13873%"
            },
            {
                "left": "16.01942%",
                "top": "79.76879%",
                "width": "5.82524%",
                "height": "12.13873%"
            },
            {
                "left": "22.81553%",
                "top": "79.76879%",
                "width": "37.62136%",
                "height": "11.56069%"
            },
            {
                "left": "61.40777%",
                "top": "79.76879%",
                "width": "4.85437%",
                "height": "12.13873%"
            },
            {
                "left": "67.47573%",
                "top": "79.76879%",
                "width": "4.85437%",
                "height": "12.13873%"
            },
            {
                "left": "73.30097%",
                "top": "79.76879%",
                "width": "5.09709%",
                "height": "12.13873%"
            },
            {
                "left": "80.82524%",
                "top": "82.65896%",
                "width": "4.85437%",
                "height": "12.13873%"
            },
            {
                "left": "92.71845%",
                "top": "82.65896%",
                "width": "5.09709%",
                "height": "12.13873%"
            },
            {
                "left": "86.89320%",
                "top": "83.23699%",
                "width": "4.85437%",
                "height": "11.56069%"
            }
        ]
    },
    "seventyfive": {
        "width": "403.0px",
        "height": "161.0px",
        "ratio": "403.000000/161.000000",
        "plateX": "1.38958%",
        "plateY": "3.47826%",
        "keys": [
            {
                "left": "2.23325%",
                "top": "5.59006%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "8.18859%",
                "top": "5.59006%",
                "width": "5.21092%",
                "height": "12.42236%"
            },
            {
                "left": "14.39206%",
                "top": "5.59006%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "20.34739%",
                "top": "5.59006%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "26.30273%",
                "top": "5.59006%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "32.25806%",
                "top": "5.59006%",
                "width": "5.21092%",
                "height": "12.42236%"
            },
            {
                "left": "38.46154%",
                "top": "5.59006%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "44.41687%",
                "top": "5.59006%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "50.62035%",
                "top": "5.59006%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "56.57568%",
                "top": "5.59006%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "62.53102%",
                "top": "5.59006%",
                "width": "5.21092%",
                "height": "12.42236%"
            },
            {
                "left": "68.48635%",
                "top": "5.59006%",
                "width": "5.21092%",
                "height": "12.42236%"
            },
            {
                "left": "74.68983%",
                "top": "5.59006%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "80.64516%",
                "top": "5.59006%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "86.84864%",
                "top": "5.59006%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "92.80397%",
                "top": "5.59006%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "2.23325%",
                "top": "20.49689%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "14.39206%",
                "top": "20.49689%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "26.30273%",
                "top": "20.49689%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "38.46154%",
                "top": "20.49689%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "50.62035%",
                "top": "20.49689%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "56.57568%",
                "top": "20.49689%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "62.53102%",
                "top": "20.49689%",
                "width": "5.21092%",
                "height": "13.04348%"
            },
            {
                "left": "68.48635%",
                "top": "20.49689%",
                "width": "5.21092%",
                "height": "13.04348%"
            },
            {
                "left": "74.68983%",
                "top": "20.49689%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "80.64516%",
                "top": "20.49689%",
                "width": "11.16625%",
                "height": "13.04348%"
            },
            {
                "left": "92.80397%",
                "top": "20.49689%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "8.18859%",
                "top": "21.11801%",
                "width": "5.21092%",
                "height": "12.42236%"
            },
            {
                "left": "20.34739%",
                "top": "21.11801%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "32.50620%",
                "top": "21.11801%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "44.41687%",
                "top": "21.11801%",
                "width": "5.21092%",
                "height": "12.42236%"
            },
            {
                "left": "2.23325%",
                "top": "36.02484%",
                "width": "7.19603%",
                "height": "12.42236%"
            },
            {
                "left": "10.42184%",
                "top": "36.02484%",
                "width": "5.21092%",
                "height": "12.42236%"
            },
            {
                "left": "16.62531%",
                "top": "36.02484%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "22.58065%",
                "top": "36.02484%",
                "width": "5.21092%",
                "height": "12.42236%"
            },
            {
                "left": "28.78412%",
                "top": "36.02484%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "34.73945%",
                "top": "36.02484%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "40.69479%",
                "top": "36.02484%",
                "width": "5.21092%",
                "height": "12.42236%"
            },
            {
                "left": "46.65012%",
                "top": "36.02484%",
                "width": "5.21092%",
                "height": "12.42236%"
            },
            {
                "left": "52.85360%",
                "top": "36.02484%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "58.80893%",
                "top": "36.02484%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "65.01241%",
                "top": "36.02484%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "70.96774%",
                "top": "36.02484%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "77.17122%",
                "top": "36.02484%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "82.87841%",
                "top": "36.02484%",
                "width": "8.93300%",
                "height": "12.42236%"
            },
            {
                "left": "92.80397%",
                "top": "36.02484%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "2.23325%",
                "top": "51.55280%",
                "width": "9.18114%",
                "height": "12.42236%"
            },
            {
                "left": "12.65509%",
                "top": "51.55280%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "18.61042%",
                "top": "51.55280%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "24.81390%",
                "top": "51.55280%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "30.76923%",
                "top": "51.55280%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "36.72457%",
                "top": "51.55280%",
                "width": "5.21092%",
                "height": "12.42236%"
            },
            {
                "left": "42.67990%",
                "top": "51.55280%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "48.88337%",
                "top": "51.55280%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "54.83871%",
                "top": "51.55280%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "61.04218%",
                "top": "51.55280%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "66.99752%",
                "top": "51.55280%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "72.95285%",
                "top": "51.55280%",
                "width": "5.21092%",
                "height": "12.42236%"
            },
            {
                "left": "79.15633%",
                "top": "51.55280%",
                "width": "12.65509%",
                "height": "12.42236%"
            },
            {
                "left": "92.80397%",
                "top": "51.55280%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "2.23325%",
                "top": "66.45963%",
                "width": "10.91811%",
                "height": "13.04348%"
            },
            {
                "left": "14.14392%",
                "top": "66.45963%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "20.09926%",
                "top": "66.45963%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "26.30273%",
                "top": "66.45963%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "32.25806%",
                "top": "66.45963%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "44.41687%",
                "top": "66.45963%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "50.37221%",
                "top": "66.45963%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "56.32754%",
                "top": "66.45963%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "62.53102%",
                "top": "66.45963%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "68.48635%",
                "top": "66.45963%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "74.68983%",
                "top": "66.45963%",
                "width": "10.91811%",
                "height": "13.04348%"
            },
            {
                "left": "86.84864%",
                "top": "66.45963%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "92.80397%",
                "top": "66.45963%",
                "width": "4.96278%",
                "height": "13.04348%"
            },
            {
                "left": "38.21340%",
                "top": "67.08075%",
                "width": "5.21092%",
                "height": "12.42236%"
            },
            {
                "left": "2.23325%",
                "top": "81.98758%",
                "width": "6.20347%",
                "height": "12.42236%"
            },
            {
                "left": "9.18114%",
                "top": "81.98758%",
                "width": "6.20347%",
                "height": "12.42236%"
            },
            {
                "left": "16.37717%",
                "top": "81.98758%",
                "width": "5.95533%",
                "height": "12.42236%"
            },
            {
                "left": "23.57320%",
                "top": "81.98758%",
                "width": "37.71712%",
                "height": "12.42236%"
            },
            {
                "left": "62.53102%",
                "top": "81.98758%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "68.48635%",
                "top": "81.98758%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "74.68983%",
                "top": "81.98758%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "80.64516%",
                "top": "81.98758%",
                "width": "4.96278%",
                "height": "12.42236%"
            },
            {
                "left": "86.60050%",
                "top": "81.98758%",
                "width": "5.21092%",
                "height": "12.42236%"
            },
            {
                "left": "92.80397%",
                "top": "81.98758%",
                "width": "4.96278%",
                "height": "12.42236%"
            }
        ]
    },
    "tenkeyless": {
        "width": "453.64px",
        "height": "169.09px",
        "ratio": "453.636364/169.090909",
        "plateX": "1.23447%",
        "plateY": "3.31183%",
        "keys": [
            {
                "left": "2.00401%",
                "top": "5.37634%",
                "width": "4.60922%",
                "height": "11.82796%"
            },
            {
                "left": "12.82565%",
                "top": "5.37634%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "18.03607%",
                "top": "5.37634%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "23.44689%",
                "top": "5.37634%",
                "width": "4.60922%",
                "height": "11.82796%"
            },
            {
                "left": "28.85772%",
                "top": "5.37634%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "36.47295%",
                "top": "5.37634%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "41.68337%",
                "top": "5.37634%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "47.09419%",
                "top": "5.37634%",
                "width": "4.60922%",
                "height": "11.82796%"
            },
            {
                "left": "52.50501%",
                "top": "5.37634%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "59.71944%",
                "top": "5.37634%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "65.13026%",
                "top": "5.37634%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "70.54108%",
                "top": "5.37634%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "75.95190%",
                "top": "5.37634%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "82.96593%",
                "top": "5.37634%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "88.37675%",
                "top": "5.37634%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "93.58717%",
                "top": "5.37634%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "2.00401%",
                "top": "24.19355%",
                "width": "4.40882%",
                "height": "12.36559%"
            },
            {
                "left": "7.41483%",
                "top": "24.19355%",
                "width": "4.40882%",
                "height": "12.36559%"
            },
            {
                "left": "12.82565%",
                "top": "24.19355%",
                "width": "4.40882%",
                "height": "12.36559%"
            },
            {
                "left": "18.03607%",
                "top": "24.19355%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "23.44689%",
                "top": "24.19355%",
                "width": "4.60922%",
                "height": "11.82796%"
            },
            {
                "left": "28.85772%",
                "top": "24.19355%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "34.26854%",
                "top": "24.19355%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "39.47896%",
                "top": "24.19355%",
                "width": "4.60922%",
                "height": "11.82796%"
            },
            {
                "left": "44.88978%",
                "top": "24.19355%",
                "width": "4.60922%",
                "height": "12.36559%"
            },
            {
                "left": "50.30060%",
                "top": "24.19355%",
                "width": "4.40882%",
                "height": "12.36559%"
            },
            {
                "left": "55.71142%",
                "top": "24.19355%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "61.12224%",
                "top": "24.19355%",
                "width": "4.40882%",
                "height": "12.36559%"
            },
            {
                "left": "66.33267%",
                "top": "24.19355%",
                "width": "4.60922%",
                "height": "11.82796%"
            },
            {
                "left": "71.74349%",
                "top": "24.19355%",
                "width": "8.61723%",
                "height": "12.36559%"
            },
            {
                "left": "82.96593%",
                "top": "24.73118%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "88.37675%",
                "top": "24.73118%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "93.58717%",
                "top": "24.73118%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "2.00401%",
                "top": "38.70968%",
                "width": "6.61323%",
                "height": "11.82796%"
            },
            {
                "left": "9.41884%",
                "top": "38.70968%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "14.82966%",
                "top": "38.70968%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "20.24048%",
                "top": "38.70968%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "25.45090%",
                "top": "38.70968%",
                "width": "4.60922%",
                "height": "11.82796%"
            },
            {
                "left": "30.86172%",
                "top": "38.70968%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "36.27255%",
                "top": "38.70968%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "41.68337%",
                "top": "38.70968%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "46.89379%",
                "top": "38.70968%",
                "width": "4.60922%",
                "height": "11.82796%"
            },
            {
                "left": "52.30461%",
                "top": "38.70968%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "57.71543%",
                "top": "38.70968%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "63.12625%",
                "top": "38.70968%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "68.33667%",
                "top": "38.70968%",
                "width": "4.60922%",
                "height": "11.82796%"
            },
            {
                "left": "73.94790%",
                "top": "38.70968%",
                "width": "6.41283%",
                "height": "11.82796%"
            },
            {
                "left": "82.96593%",
                "top": "38.70968%",
                "width": "4.40882%",
                "height": "12.36559%"
            },
            {
                "left": "88.37675%",
                "top": "39.24731%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "93.58717%",
                "top": "39.24731%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "2.00401%",
                "top": "53.76344%",
                "width": "8.21643%",
                "height": "11.82796%"
            },
            {
                "left": "11.22244%",
                "top": "53.76344%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "16.63327%",
                "top": "53.76344%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "21.84369%",
                "top": "53.76344%",
                "width": "4.60922%",
                "height": "11.82796%"
            },
            {
                "left": "27.45491%",
                "top": "53.76344%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "32.66533%",
                "top": "53.76344%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "38.07615%",
                "top": "53.76344%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "43.48697%",
                "top": "53.76344%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "48.89780%",
                "top": "53.76344%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "54.10822%",
                "top": "53.76344%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "59.51904%",
                "top": "53.76344%",
                "width": "4.60922%",
                "height": "11.82796%"
            },
            {
                "left": "64.92986%",
                "top": "53.76344%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "70.34068%",
                "top": "53.76344%",
                "width": "10.02004%",
                "height": "11.82796%"
            },
            {
                "left": "2.00401%",
                "top": "67.74194%",
                "width": "9.81964%",
                "height": "12.36559%"
            },
            {
                "left": "12.82565%",
                "top": "67.74194%",
                "width": "4.40882%",
                "height": "12.36559%"
            },
            {
                "left": "18.03607%",
                "top": "67.74194%",
                "width": "4.60922%",
                "height": "12.36559%"
            },
            {
                "left": "23.64729%",
                "top": "67.74194%",
                "width": "4.40882%",
                "height": "12.36559%"
            },
            {
                "left": "28.85772%",
                "top": "67.74194%",
                "width": "4.40882%",
                "height": "12.36559%"
            },
            {
                "left": "34.26854%",
                "top": "67.74194%",
                "width": "4.60922%",
                "height": "12.36559%"
            },
            {
                "left": "39.67936%",
                "top": "67.74194%",
                "width": "4.40882%",
                "height": "12.36559%"
            },
            {
                "left": "45.09018%",
                "top": "67.74194%",
                "width": "4.40882%",
                "height": "12.36559%"
            },
            {
                "left": "50.30060%",
                "top": "67.74194%",
                "width": "4.40882%",
                "height": "12.36559%"
            },
            {
                "left": "55.91182%",
                "top": "67.74194%",
                "width": "4.40882%",
                "height": "12.36559%"
            },
            {
                "left": "61.12224%",
                "top": "67.74194%",
                "width": "4.40882%",
                "height": "12.36559%"
            },
            {
                "left": "66.53307%",
                "top": "67.74194%",
                "width": "13.82766%",
                "height": "12.36559%"
            },
            {
                "left": "88.37675%",
                "top": "68.27957%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "2.00401%",
                "top": "82.25806%",
                "width": "5.41082%",
                "height": "11.82796%"
            },
            {
                "left": "8.41683%",
                "top": "82.25806%",
                "width": "5.21042%",
                "height": "11.82796%"
            },
            {
                "left": "14.62926%",
                "top": "82.25806%",
                "width": "5.41082%",
                "height": "11.82796%"
            },
            {
                "left": "20.84168%",
                "top": "82.25806%",
                "width": "34.26854%",
                "height": "12.36559%"
            },
            {
                "left": "56.11222%",
                "top": "82.25806%",
                "width": "5.41082%",
                "height": "11.82796%"
            },
            {
                "left": "62.52505%",
                "top": "82.25806%",
                "width": "5.21042%",
                "height": "11.82796%"
            },
            {
                "left": "68.73747%",
                "top": "82.25806%",
                "width": "5.41082%",
                "height": "11.82796%"
            },
            {
                "left": "74.94990%",
                "top": "82.25806%",
                "width": "5.41082%",
                "height": "11.82796%"
            },
            {
                "left": "82.96593%",
                "top": "82.25806%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "88.37675%",
                "top": "82.25806%",
                "width": "4.40882%",
                "height": "11.82796%"
            },
            {
                "left": "93.58717%",
                "top": "82.25806%",
                "width": "4.40882%",
                "height": "11.82796%"
            }
        ]
    },
    "ninetysix": {
        "width": "461.74px",
        "height": "155.65px",
        "ratio": "461.739130/155.652174",
        "plateX": "1.21281%",
        "plateY": "3.59777%",
        "keys": [
            {
                "left": "1.88324%",
                "top": "5.58659%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "6.77966%",
                "top": "5.58659%",
                "width": "4.51977%",
                "height": "12.84916%"
            },
            {
                "left": "12.05273%",
                "top": "5.58659%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "17.13748%",
                "top": "5.58659%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "22.22222%",
                "top": "5.58659%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "27.30697%",
                "top": "5.58659%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "32.58004%",
                "top": "5.58659%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "37.47646%",
                "top": "5.58659%",
                "width": "4.51977%",
                "height": "12.84916%"
            },
            {
                "left": "42.74953%",
                "top": "5.58659%",
                "width": "4.14313%",
                "height": "12.84916%"
            },
            {
                "left": "47.83427%",
                "top": "5.58659%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "52.91902%",
                "top": "5.58659%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "58.00377%",
                "top": "5.58659%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "63.08851%",
                "top": "5.58659%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "68.36158%",
                "top": "5.58659%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "73.25800%",
                "top": "5.58659%",
                "width": "4.51977%",
                "height": "12.84916%"
            },
            {
                "left": "78.53107%",
                "top": "5.58659%",
                "width": "4.14313%",
                "height": "12.84916%"
            },
            {
                "left": "83.42750%",
                "top": "5.58659%",
                "width": "4.51977%",
                "height": "12.84916%"
            },
            {
                "left": "88.70056%",
                "top": "5.58659%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "93.78531%",
                "top": "5.58659%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "1.88324%",
                "top": "20.67039%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "6.77966%",
                "top": "20.67039%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "11.86441%",
                "top": "20.67039%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "16.94915%",
                "top": "20.67039%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "21.84557%",
                "top": "20.67039%",
                "width": "4.51977%",
                "height": "12.84916%"
            },
            {
                "left": "27.11864%",
                "top": "20.67039%",
                "width": "4.14313%",
                "height": "12.84916%"
            },
            {
                "left": "32.01507%",
                "top": "20.67039%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "37.09981%",
                "top": "20.67039%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "42.18456%",
                "top": "20.67039%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "47.26930%",
                "top": "20.67039%",
                "width": "4.14313%",
                "height": "12.84916%"
            },
            {
                "left": "52.16573%",
                "top": "20.67039%",
                "width": "4.51977%",
                "height": "12.84916%"
            },
            {
                "left": "57.25047%",
                "top": "20.67039%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "62.33522%",
                "top": "20.67039%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "67.41996%",
                "top": "20.67039%",
                "width": "10.16949%",
                "height": "12.84916%"
            },
            {
                "left": "78.53107%",
                "top": "20.67039%",
                "width": "4.14313%",
                "height": "12.84916%"
            },
            {
                "left": "83.61582%",
                "top": "20.67039%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "88.70056%",
                "top": "21.22905%",
                "width": "4.33145%",
                "height": "12.29050%"
            },
            {
                "left": "93.78531%",
                "top": "21.22905%",
                "width": "4.33145%",
                "height": "12.29050%"
            },
            {
                "left": "1.88324%",
                "top": "35.75419%",
                "width": "6.21469%",
                "height": "12.84916%"
            },
            {
                "left": "8.85122%",
                "top": "35.75419%",
                "width": "4.14313%",
                "height": "12.84916%"
            },
            {
                "left": "13.74765%",
                "top": "35.75419%",
                "width": "4.51977%",
                "height": "12.84916%"
            },
            {
                "left": "18.83239%",
                "top": "35.75419%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "23.91714%",
                "top": "35.75419%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "29.00188%",
                "top": "35.75419%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "33.89831%",
                "top": "35.75419%",
                "width": "4.51977%",
                "height": "12.84916%"
            },
            {
                "left": "39.17137%",
                "top": "35.75419%",
                "width": "4.14313%",
                "height": "12.84916%"
            },
            {
                "left": "44.06780%",
                "top": "35.75419%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "49.15254%",
                "top": "35.75419%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "54.04896%",
                "top": "35.75419%",
                "width": "4.51977%",
                "height": "12.84916%"
            },
            {
                "left": "59.32203%",
                "top": "35.75419%",
                "width": "4.14313%",
                "height": "12.84916%"
            },
            {
                "left": "64.21846%",
                "top": "35.75419%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "69.30320%",
                "top": "35.75419%",
                "width": "8.47458%",
                "height": "12.84916%"
            },
            {
                "left": "78.53107%",
                "top": "35.75419%",
                "width": "4.14313%",
                "height": "12.84916%"
            },
            {
                "left": "83.61582%",
                "top": "35.75419%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "88.70056%",
                "top": "35.75419%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "93.78531%",
                "top": "35.75419%",
                "width": "4.33145%",
                "height": "27.93296%"
            },
            {
                "left": "1.88324%",
                "top": "50.83799%",
                "width": "7.90960%",
                "height": "12.84916%"
            },
            {
                "left": "10.35782%",
                "top": "50.83799%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "15.63089%",
                "top": "50.83799%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "20.52731%",
                "top": "50.83799%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "25.61205%",
                "top": "50.83799%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "30.69680%",
                "top": "50.83799%",
                "width": "4.14313%",
                "height": "12.84916%"
            },
            {
                "left": "35.78154%",
                "top": "50.83799%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "40.67797%",
                "top": "50.83799%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "45.76271%",
                "top": "50.83799%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "50.84746%",
                "top": "50.83799%",
                "width": "4.14313%",
                "height": "12.84916%"
            },
            {
                "left": "55.93220%",
                "top": "50.83799%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "61.01695%",
                "top": "50.83799%",
                "width": "4.14313%",
                "height": "12.84916%"
            },
            {
                "left": "66.10169%",
                "top": "50.83799%",
                "width": "11.67608%",
                "height": "12.84916%"
            },
            {
                "left": "78.53107%",
                "top": "50.83799%",
                "width": "4.14313%",
                "height": "12.84916%"
            },
            {
                "left": "83.61582%",
                "top": "50.83799%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "88.70056%",
                "top": "50.83799%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "1.88324%",
                "top": "65.92179%",
                "width": "9.22787%",
                "height": "12.84916%"
            },
            {
                "left": "12.05273%",
                "top": "65.92179%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "16.94915%",
                "top": "65.92179%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "22.22222%",
                "top": "65.92179%",
                "width": "4.14313%",
                "height": "12.84916%"
            },
            {
                "left": "27.11864%",
                "top": "65.92179%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "32.20339%",
                "top": "65.92179%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "37.09981%",
                "top": "65.92179%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "42.37288%",
                "top": "65.92179%",
                "width": "4.14313%",
                "height": "12.84916%"
            },
            {
                "left": "47.26930%",
                "top": "65.92179%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "52.35405%",
                "top": "65.92179%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "57.25047%",
                "top": "65.92179%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "62.52354%",
                "top": "65.92179%",
                "width": "10.16949%",
                "height": "12.84916%"
            },
            {
                "left": "73.44633%",
                "top": "65.92179%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "78.53107%",
                "top": "65.92179%",
                "width": "4.14313%",
                "height": "12.84916%"
            },
            {
                "left": "83.61582%",
                "top": "65.92179%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "88.70056%",
                "top": "65.92179%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "93.78531%",
                "top": "66.48045%",
                "width": "4.33145%",
                "height": "27.37430%"
            },
            {
                "left": "1.88324%",
                "top": "81.00559%",
                "width": "5.08475%",
                "height": "12.84916%"
            },
            {
                "left": "7.72128%",
                "top": "81.00559%",
                "width": "5.08475%",
                "height": "12.84916%"
            },
            {
                "left": "13.74765%",
                "top": "81.00559%",
                "width": "5.08475%",
                "height": "12.84916%"
            },
            {
                "left": "19.58569%",
                "top": "81.00559%",
                "width": "32.76836%",
                "height": "12.84916%"
            },
            {
                "left": "53.10734%",
                "top": "81.00559%",
                "width": "4.33145%",
                "height": "13.40782%"
            },
            {
                "left": "58.19209%",
                "top": "81.00559%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "63.27684%",
                "top": "81.00559%",
                "width": "4.14313%",
                "height": "13.40782%"
            },
            {
                "left": "68.36158%",
                "top": "81.00559%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "73.44633%",
                "top": "81.00559%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "78.53107%",
                "top": "81.00559%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "83.61582%",
                "top": "81.00559%",
                "width": "4.33145%",
                "height": "12.84916%"
            },
            {
                "left": "88.70056%",
                "top": "81.00559%",
                "width": "4.33145%",
                "height": "12.84916%"
            }
        ]
    },
    "fullsize": {
        "width": "560.67px",
        "height": "170.0px",
        "ratio": "560.666667/170.000000",
        "plateX": "0.99881%",
        "plateY": "3.29412%",
        "keys": [
            {
                "left": "1.78359%",
                "top": "5.88235%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "10.46373%",
                "top": "5.88235%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "14.86326%",
                "top": "5.88235%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "19.14388%",
                "top": "5.88235%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "23.54340%",
                "top": "5.88235%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "29.48870%",
                "top": "5.49020%",
                "width": "3.68609%",
                "height": "11.76471%"
            },
            {
                "left": "33.88823%",
                "top": "5.49020%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "38.16885%",
                "top": "5.49020%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "42.56837%",
                "top": "5.49020%",
                "width": "3.68609%",
                "height": "11.76471%"
            },
            {
                "left": "48.51367%",
                "top": "5.88235%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "52.79429%",
                "top": "5.88235%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "57.19382%",
                "top": "5.88235%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "61.47444%",
                "top": "5.88235%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "67.30083%",
                "top": "5.88235%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "71.46254%",
                "top": "5.88235%",
                "width": "3.68609%",
                "height": "11.76471%"
            },
            {
                "left": "75.98098%",
                "top": "5.88235%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "1.66468%",
                "top": "24.70588%",
                "width": "3.68609%",
                "height": "12.15686%"
            },
            {
                "left": "6.18312%",
                "top": "24.70588%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "10.46373%",
                "top": "24.70588%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "14.86326%",
                "top": "24.70588%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "19.14388%",
                "top": "24.70588%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "23.54340%",
                "top": "24.70588%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "27.82402%",
                "top": "24.70588%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "32.22354%",
                "top": "24.70588%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "36.50416%",
                "top": "24.70588%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "40.90369%",
                "top": "24.70588%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "45.18430%",
                "top": "24.70588%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "49.46492%",
                "top": "24.70588%",
                "width": "3.68609%",
                "height": "12.15686%"
            },
            {
                "left": "53.86445%",
                "top": "24.70588%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "58.14507%",
                "top": "24.70588%",
                "width": "6.89655%",
                "height": "12.15686%"
            },
            {
                "left": "67.30083%",
                "top": "25.09804%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "71.46254%",
                "top": "25.09804%",
                "width": "3.68609%",
                "height": "11.76471%"
            },
            {
                "left": "75.98098%",
                "top": "25.09804%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "81.56956%",
                "top": "24.70588%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "85.85018%",
                "top": "24.70588%",
                "width": "3.68609%",
                "height": "11.76471%"
            },
            {
                "left": "90.24970%",
                "top": "24.70588%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "94.76813%",
                "top": "25.09804%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "1.78359%",
                "top": "38.82353%",
                "width": "5.23187%",
                "height": "12.15686%"
            },
            {
                "left": "7.84780%",
                "top": "38.82353%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "12.12842%",
                "top": "38.82353%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "16.52794%",
                "top": "38.82353%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "20.80856%",
                "top": "38.82353%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "25.20809%",
                "top": "38.82353%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "29.48870%",
                "top": "38.82353%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "33.76932%",
                "top": "38.82353%",
                "width": "3.68609%",
                "height": "12.15686%"
            },
            {
                "left": "38.16885%",
                "top": "38.82353%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "42.44946%",
                "top": "38.82353%",
                "width": "3.68609%",
                "height": "12.15686%"
            },
            {
                "left": "46.84899%",
                "top": "38.82353%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "51.12961%",
                "top": "38.82353%",
                "width": "3.68609%",
                "height": "12.15686%"
            },
            {
                "left": "55.52913%",
                "top": "39.21569%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "59.80975%",
                "top": "39.21569%",
                "width": "5.23187%",
                "height": "11.76471%"
            },
            {
                "left": "67.30083%",
                "top": "39.60784%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "71.46254%",
                "top": "39.60784%",
                "width": "3.68609%",
                "height": "11.76471%"
            },
            {
                "left": "75.98098%",
                "top": "39.60784%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "81.56956%",
                "top": "38.82353%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "85.85018%",
                "top": "39.21569%",
                "width": "3.68609%",
                "height": "12.15686%"
            },
            {
                "left": "90.24970%",
                "top": "38.82353%",
                "width": "3.56718%",
                "height": "12.54902%"
            },
            {
                "left": "94.76813%",
                "top": "39.60784%",
                "width": "3.56718%",
                "height": "25.88235%"
            },
            {
                "left": "17.95482%",
                "top": "53.33333%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "52.67539%",
                "top": "53.33333%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "1.78359%",
                "top": "53.72549%",
                "width": "6.65874%",
                "height": "11.76471%"
            },
            {
                "left": "9.27467%",
                "top": "53.72549%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "13.55529%",
                "top": "53.72549%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "22.23543%",
                "top": "53.72549%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "26.63496%",
                "top": "53.72549%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "30.91558%",
                "top": "53.72549%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "35.31510%",
                "top": "53.72549%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "39.59572%",
                "top": "53.72549%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "43.99524%",
                "top": "53.72549%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "48.27586%",
                "top": "53.72549%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "56.95600%",
                "top": "53.72549%",
                "width": "8.20452%",
                "height": "11.76471%"
            },
            {
                "left": "81.56956%",
                "top": "53.72549%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "85.85018%",
                "top": "53.72549%",
                "width": "3.68609%",
                "height": "11.76471%"
            },
            {
                "left": "90.24970%",
                "top": "53.72549%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "1.66468%",
                "top": "68.23529%",
                "width": "8.08561%",
                "height": "11.76471%"
            },
            {
                "left": "10.46373%",
                "top": "68.23529%",
                "width": "3.68609%",
                "height": "11.76471%"
            },
            {
                "left": "14.86326%",
                "top": "68.23529%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "19.14388%",
                "top": "68.23529%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "23.54340%",
                "top": "68.23529%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "27.82402%",
                "top": "68.23529%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "32.22354%",
                "top": "68.23529%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "36.50416%",
                "top": "68.23529%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "40.90369%",
                "top": "68.23529%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "45.18430%",
                "top": "68.23529%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "49.58383%",
                "top": "68.23529%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "53.86445%",
                "top": "68.23529%",
                "width": "11.29608%",
                "height": "11.76471%"
            },
            {
                "left": "71.46254%",
                "top": "68.23529%",
                "width": "3.68609%",
                "height": "11.76471%"
            },
            {
                "left": "81.56956%",
                "top": "68.23529%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "85.85018%",
                "top": "68.23529%",
                "width": "3.68609%",
                "height": "11.76471%"
            },
            {
                "left": "90.24970%",
                "top": "68.23529%",
                "width": "3.56718%",
                "height": "11.76471%"
            },
            {
                "left": "94.76813%",
                "top": "68.23529%",
                "width": "3.56718%",
                "height": "25.88235%"
            },
            {
                "left": "1.78359%",
                "top": "82.35294%",
                "width": "4.39952%",
                "height": "12.15686%"
            },
            {
                "left": "6.77765%",
                "top": "82.35294%",
                "width": "4.39952%",
                "height": "11.76471%"
            },
            {
                "left": "12.00951%",
                "top": "82.35294%",
                "width": "4.28062%",
                "height": "11.76471%"
            },
            {
                "left": "17.12247%",
                "top": "82.35294%",
                "width": "27.70511%",
                "height": "12.15686%"
            },
            {
                "left": "45.42212%",
                "top": "82.35294%",
                "width": "4.39952%",
                "height": "12.15686%"
            },
            {
                "left": "50.53508%",
                "top": "82.35294%",
                "width": "4.39952%",
                "height": "12.15686%"
            },
            {
                "left": "55.76694%",
                "top": "82.35294%",
                "width": "4.16171%",
                "height": "12.15686%"
            },
            {
                "left": "60.87990%",
                "top": "82.35294%",
                "width": "4.28062%",
                "height": "12.15686%"
            },
            {
                "left": "67.30083%",
                "top": "82.35294%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "71.46254%",
                "top": "82.35294%",
                "width": "3.68609%",
                "height": "12.15686%"
            },
            {
                "left": "75.98098%",
                "top": "82.35294%",
                "width": "3.56718%",
                "height": "12.15686%"
            },
            {
                "left": "81.56956%",
                "top": "82.35294%",
                "width": "7.96671%",
                "height": "12.15686%"
            },
            {
                "left": "90.24970%",
                "top": "82.35294%",
                "width": "3.56718%",
                "height": "11.76471%"
            }
        ]
    },
    "eighteenhundred": {
        "width": "463.85px",
        "height": "164.62px",
        "ratio": "463.846154/164.615385",
        "plateX": "1.20730%",
        "plateY": "3.40187%",
        "keys": [
            {
                "left": "78.77280%",
                "top": "5.60748%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "83.74793%",
                "top": "5.60748%",
                "width": "4.14594%",
                "height": "12.14953%"
            },
            {
                "left": "88.72305%",
                "top": "5.60748%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "93.69818%",
                "top": "5.60748%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "1.99005%",
                "top": "6.07477%",
                "width": "4.14594%",
                "height": "12.14953%"
            },
            {
                "left": "8.12604%",
                "top": "6.07477%",
                "width": "4.14594%",
                "height": "12.14953%"
            },
            {
                "left": "13.10116%",
                "top": "6.07477%",
                "width": "4.14594%",
                "height": "12.14953%"
            },
            {
                "left": "17.91045%",
                "top": "6.07477%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "22.88557%",
                "top": "6.07477%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "29.18740%",
                "top": "6.07477%",
                "width": "4.14594%",
                "height": "12.14953%"
            },
            {
                "left": "33.99668%",
                "top": "6.07477%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "38.97181%",
                "top": "6.07477%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "43.94693%",
                "top": "6.07477%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "50.08292%",
                "top": "6.07477%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "55.05804%",
                "top": "6.07477%",
                "width": "4.14594%",
                "height": "12.14953%"
            },
            {
                "left": "60.19900%",
                "top": "6.07477%",
                "width": "4.14594%",
                "height": "12.14953%"
            },
            {
                "left": "65.00829%",
                "top": "6.07477%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "71.14428%",
                "top": "6.07477%",
                "width": "4.14594%",
                "height": "12.14953%"
            },
            {
                "left": "1.99005%",
                "top": "23.36449%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "6.79934%",
                "top": "23.36449%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "11.77446%",
                "top": "23.36449%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "16.58375%",
                "top": "23.36449%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "21.55887%",
                "top": "23.36449%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "26.36816%",
                "top": "23.36449%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "31.34328%",
                "top": "23.36449%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "36.15257%",
                "top": "23.36449%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "41.12769%",
                "top": "23.36449%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "45.93698%",
                "top": "23.36449%",
                "width": "4.14594%",
                "height": "12.14953%"
            },
            {
                "left": "50.91211%",
                "top": "23.36449%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "55.72139%",
                "top": "23.36449%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "60.53068%",
                "top": "23.36449%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "65.50580%",
                "top": "23.36449%",
                "width": "10.11609%",
                "height": "11.68224%"
            },
            {
                "left": "78.77280%",
                "top": "23.36449%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "83.74793%",
                "top": "23.36449%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "88.72305%",
                "top": "23.36449%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "93.69818%",
                "top": "23.36449%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "78.77280%",
                "top": "36.91589%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "83.74793%",
                "top": "36.91589%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "88.88889%",
                "top": "36.91589%",
                "width": "4.14594%",
                "height": "12.14953%"
            },
            {
                "left": "1.99005%",
                "top": "37.38318%",
                "width": "6.13599%",
                "height": "11.68224%"
            },
            {
                "left": "8.62355%",
                "top": "37.38318%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "13.59867%",
                "top": "37.38318%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "18.40796%",
                "top": "37.38318%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "23.38308%",
                "top": "37.38318%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "28.19237%",
                "top": "37.38318%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "33.16750%",
                "top": "37.38318%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "37.97678%",
                "top": "37.38318%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "42.95191%",
                "top": "37.38318%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "47.76119%",
                "top": "37.38318%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "52.57048%",
                "top": "37.38318%",
                "width": "4.47761%",
                "height": "11.68224%"
            },
            {
                "left": "57.54561%",
                "top": "37.38318%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "62.35489%",
                "top": "37.38318%",
                "width": "4.47761%",
                "height": "11.68224%"
            },
            {
                "left": "67.33002%",
                "top": "37.38318%",
                "width": "8.29187%",
                "height": "11.68224%"
            },
            {
                "left": "93.69818%",
                "top": "37.38318%",
                "width": "4.31177%",
                "height": "25.70093%"
            },
            {
                "left": "15.25705%",
                "top": "50.93458%",
                "width": "4.31177%",
                "height": "12.61682%"
            },
            {
                "left": "25.04146%",
                "top": "50.93458%",
                "width": "4.31177%",
                "height": "12.61682%"
            },
            {
                "left": "39.63516%",
                "top": "50.93458%",
                "width": "4.31177%",
                "height": "12.61682%"
            },
            {
                "left": "44.61028%",
                "top": "50.93458%",
                "width": "4.14594%",
                "height": "12.61682%"
            },
            {
                "left": "78.77280%",
                "top": "50.93458%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "83.74793%",
                "top": "50.93458%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "88.88889%",
                "top": "50.93458%",
                "width": "4.14594%",
                "height": "12.14953%"
            },
            {
                "left": "1.99005%",
                "top": "51.40187%",
                "width": "7.62852%",
                "height": "12.14953%"
            },
            {
                "left": "10.28192%",
                "top": "51.40187%",
                "width": "4.47761%",
                "height": "12.14953%"
            },
            {
                "left": "20.06633%",
                "top": "51.40187%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "29.85075%",
                "top": "51.40187%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "34.82587%",
                "top": "51.40187%",
                "width": "4.14594%",
                "height": "12.14953%"
            },
            {
                "left": "49.41957%",
                "top": "51.40187%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "54.39469%",
                "top": "51.40187%",
                "width": "4.14594%",
                "height": "12.14953%"
            },
            {
                "left": "59.20398%",
                "top": "51.40187%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "64.17910%",
                "top": "51.40187%",
                "width": "11.44279%",
                "height": "12.14953%"
            },
            {
                "left": "1.99005%",
                "top": "64.95327%",
                "width": "9.12106%",
                "height": "12.14953%"
            },
            {
                "left": "11.77446%",
                "top": "64.95327%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "16.58375%",
                "top": "64.95327%",
                "width": "4.47761%",
                "height": "12.14953%"
            },
            {
                "left": "21.55887%",
                "top": "64.95327%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "26.36816%",
                "top": "64.95327%",
                "width": "4.47761%",
                "height": "12.14953%"
            },
            {
                "left": "31.34328%",
                "top": "64.95327%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "36.15257%",
                "top": "64.95327%",
                "width": "4.47761%",
                "height": "12.14953%"
            },
            {
                "left": "41.12769%",
                "top": "64.95327%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "45.93698%",
                "top": "64.95327%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "50.91211%",
                "top": "64.95327%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "55.72139%",
                "top": "64.95327%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "60.69652%",
                "top": "64.95327%",
                "width": "9.95025%",
                "height": "12.14953%"
            },
            {
                "left": "78.77280%",
                "top": "64.95327%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "83.74793%",
                "top": "64.95327%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "88.72305%",
                "top": "64.95327%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "93.69818%",
                "top": "64.95327%",
                "width": "4.31177%",
                "height": "25.70093%"
            },
            {
                "left": "72.47098%",
                "top": "68.69159%",
                "width": "4.47761%",
                "height": "11.68224%"
            },
            {
                "left": "83.74793%",
                "top": "78.50467%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "88.88889%",
                "top": "78.50467%",
                "width": "4.14594%",
                "height": "12.14953%"
            },
            {
                "left": "7.79436%",
                "top": "78.97196%",
                "width": "4.97512%",
                "height": "12.14953%"
            },
            {
                "left": "13.43284%",
                "top": "78.97196%",
                "width": "5.14096%",
                "height": "12.14953%"
            },
            {
                "left": "19.07131%",
                "top": "78.97196%",
                "width": "32.00663%",
                "height": "12.14953%"
            },
            {
                "left": "1.99005%",
                "top": "79.43925%",
                "width": "5.14096%",
                "height": "11.68224%"
            },
            {
                "left": "51.57546%",
                "top": "79.43925%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "56.55058%",
                "top": "79.43925%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "61.35987%",
                "top": "79.43925%",
                "width": "4.31177%",
                "height": "11.68224%"
            },
            {
                "left": "72.47098%",
                "top": "82.24299%",
                "width": "4.47761%",
                "height": "12.14953%"
            },
            {
                "left": "77.44610%",
                "top": "82.24299%",
                "width": "4.31177%",
                "height": "12.14953%"
            },
            {
                "left": "67.66169%",
                "top": "82.71028%",
                "width": "4.14594%",
                "height": "11.68224%"
            }
        ]
    }
};

export default keyboardSilhouetteLayouts;
